<div class="content">
    <h2 showdown [showDelay]="100">What We Believe</h2>
    <div class="cards">
        <div class="card" showleft [showDelay]="50">
            <div class="icon">
                <mat-icon fontSet="material-symbols-outlined" inline>checkroom</mat-icon>
            </div>
            <h4>Soft Lace First</h4>
            <p>Lace should feel gentle, breathable, and easy to wear from everyday tops to romantic dresses.</p>
        </div>
        <div class="card" showleft [showDelay]="150">
            <div class="icon">
                <mat-icon fontSet="material-symbols-outlined" inline>favorite</mat-icon>
            </div>
            <h4>Everyday Romance</h4>
            <p>Feminine details should fit real life, bringing quiet confidence to ordinary days and special plans.</p>
        </div>
        <div class="card" showleft [showDelay]="250">
            <div class="icon">
                <mat-icon fontSet="material-symbols-outlined" inline>featured_seasonal_and_gifts</mat-icon>
            </div>
            <h4>Thoughtful Details</h4>
            <p>From sheerness and trims to fit and packaging, every detail is chosen to feel intentional.</p>
        </div>
    </div>
</div>